<template>
  <div id="Part01">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  name: 'Part01',
}
</script>

<style lang="scss" scoped>
#Part01 {
  text-align: center;
  & > div {
    height: 100%;
  }
}
</style>
